var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/*
 * @FilePath: \kitchen-online-web\src\components\SideBar\sideBar.tsx
 * @Author: yehao Gao
 * @Date: 2021-12-20 10:20:32
 * @LastEditors: Dai Guo
 * @LastEditTime: 2022-06-16 15:53:50
 */
import { useEffect, useState, useContext, } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { AppContext } from '@/redux/store';
import barSetting from '@/assets/barSetting.svg';
import barDown from '@/assets/barDown.svg';
import wall from '@/assets/wall.svg';
import ground from '@/assets/ground.svg';
import window from '@/assets/window.svg';
import nowindow from '@/assets/nowindow.svg';
import ruler from '@/assets/ruler.svg';
import OptionsCard from '@/components/OptionsCard/optionsCard';
import callEngine from '@/3DEngine/callEngine';
import { updateFloor, updateWall } from '@/apis/homePage';
import style from './SideBar.module.scss';
function SideBar(props) {
    const { pathname, floorList, wallList, isHome, } = props;
    const [openState, setopenState] = useState(true); // 开关状态
    const { initState, dispatch } = useContext(AppContext);
    // const [isFirstPage, setisFirstPage] = useState(true); // 是否是第一个页面也就是尺寸页面
    const [type, settype] = useState(0); // 墙面还是地面，地面0，墙面1
    const [visible, setvisible] = useState(false); // 墙面地面选择栏是否打开状态
    const [listWall, setListWall] = useState([]); // 墙面列表
    const [listFloor, setListFloor] = useState([]); // 地面列表
    const [selectedFloorId, setselectedFloorId] = useState(0); // 地面选择id
    const [selectedWallId, setselectedWallId] = useState(0); // 墙面选择id
    // const [tipPosition, settipPosition] = useState(0);// touchMove提示位置
    const { t } = useTranslation();
    const [items, setitems] = useState([
        {
            img: ground,
            text: t('other.groundColor'),
            key: 0,
        },
        {
            img: wall,
            text: t('other.wallColor'),
            key: 1,
        },
        {
            img: window,
            text: t('other.window'),
            key: 2,
        },
        {
            img: ruler,
            text: t('other.scale'),
            key: 3,
        },
    ]);
    useEffect(() => {
        // 这边监听pathname和用作判断的原因是当点击浏览器自带的返回键时，需要用pathname判断
        setopenState(false); // 当currentTitle改变或者路由变化时，开关设为false
    }, [initState.currentTitle, pathname]);
    useEffect(() => {
        setitems([
            {
                img: ground,
                text: t('other.groundColor'),
                key: 0,
            },
            {
                img: wall,
                text: t('other.wallColor'),
                key: 1,
            },
            {
                img: initState.existWindow ? window : nowindow,
                text: t('other.window'),
                key: 2,
            },
            {
                img: ruler,
                text: t('other.scale'),
                key: 3,
            },
        ]);
        if (initState.existWindow && !initState.isWindow) { // 如果原本是没有窗户，但是切换模型后窗户打开，那么需要再次把窗户关了
            dispatch({ type: 'isWindow', payload: false });
        }
    }, [initState.existWindow]);
    useEffect(() => {
        var _a;
        const list = floorList.map((item) => ({
            url: item.imageUrl,
            id: item.id,
        }));
        setListFloor(list);
        const selectId = (_a = list.filter((item) => { var _a, _b, _c; return item.id === ((_c = (_b = (_a = initState === null || initState === void 0 ? void 0 : initState.jsonTemplate) === null || _a === void 0 ? void 0 : _a.other) === null || _b === void 0 ? void 0 : _b.floor) === null || _c === void 0 ? void 0 : _c.componentId); })[0]) === null || _a === void 0 ? void 0 : _a.id;
        // 初始化时没有jsonTemplate，selectId为undefined
        if (selectId)
            setselectedFloorId(selectId);
    }, [floorList, initState.jsonTemplate]);
    useEffect(() => {
        var _a;
        const list = wallList.map((item) => ({
            url: item.imageUrl,
            id: item.id,
        }));
        setListWall(list);
        const selectId = (_a = list.filter((item) => { var _a, _b, _c; return item.id === ((_c = (_b = (_a = initState === null || initState === void 0 ? void 0 : initState.jsonTemplate) === null || _a === void 0 ? void 0 : _a.other) === null || _b === void 0 ? void 0 : _b.wall) === null || _c === void 0 ? void 0 : _c.componentId); })[0]) === null || _a === void 0 ? void 0 : _a.id;
        // 初始化时没有jsonTemplate，selectId为undefined
        if (selectId)
            setselectedWallId(selectId);
    }, [wallList, initState.jsonTemplate]);
    useEffect(() => {
        if (!openState || !initState.filterColor) {
            setvisible(false);
        }
    }, [openState, initState.filterColor]);
    const offOnFn = (e) => {
        if (openState) { // 当侧边栏收缩时，墙面地面选择栏需关闭
            setvisible(false);
        }
        setopenState(!openState);
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
    };
    const ontouchStart = (e) => {
        e.nativeEvent.stopImmediatePropagation();
        e.stopPropagation();
    };
    const itemClick = (e, key) => {
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
        switch (key) {
            case 0:
                if (!type) {
                    if (!visible) {
                        dispatch({ type: 'filterColor', payload: true });
                    }
                    setvisible(!visible);
                }
                else if (!visible) {
                    setvisible(true);
                    dispatch({ type: 'filterColor', payload: true });
                }
                settype(key);
                break;
            case 1:
                if (type) {
                    if (!visible) {
                        dispatch({ type: 'filterColor', payload: true });
                    }
                    setvisible(!visible);
                }
                else if (!visible) {
                    setvisible(true);
                    dispatch({ type: 'filterColor', payload: true });
                }
                settype(key);
                break;
            case 2:
                dispatch({ type: 'filterColor', payload: false });
                if (!initState.existWindow) {
                    return;
                }
                callEngine(initState.engine3D, 'window', !initState.isWindow, undefined)
                    .then((visiable) => console.log(visiable));
                dispatch({ type: 'isWindow', payload: !initState.isWindow });
                break;
            case 3:
                dispatch({ type: 'filterColor', payload: false });
                if (isHome) {
                    callEngine(initState.engine3D, 'calloutLine', !initState.sizeMark, undefined);
                    dispatch({ type: 'sizeMark', payload: !initState.sizeMark });
                }
                else {
                    callEngine(initState.engine3D, 'calloutLine', !initState.otherMark, undefined);
                    dispatch({ type: 'otherMark', payload: !initState.otherMark });
                }
                break;
            default:
        }
    };
    const colorClick = (type, id) => __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        if (type) {
            setselectedWallId(id);
            const res = yield updateWall({ mccInitVO: initState.jsonTemplate, componentId: id });
            if ((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.data) {
                callEngine(initState.engine3D, 'wall', undefined, res.data.data.mccInitVO).then(() => {
                    dispatch({ type: 'json-template', payload: res.data.data.mccInitVO });
                }).catch();
            }
        }
        else {
            setselectedFloorId(id);
            const res = yield updateFloor({ mccInitVO: initState.jsonTemplate, componentId: id });
            if ((_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.data) {
                callEngine(initState.engine3D, 'ground', undefined, res.data.data.mccInitVO).then((r) => {
                    dispatch({ type: 'json-template', payload: res.data.data.mccInitVO });
                    console.log(r);
                }).catch((e) => {
                    console.log(e);
                });
            }
        }
    });
    const touchEnd = (e) => {
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
    };
    return (_jsxs("div", Object.assign({ className: style.container, style: {
            height: openState ? `${4 * 3.1875 + 1.5 + 2.25 - 0.25}rem` : '3.25rem',
            display: pathname.includes('steptwo') || pathname.includes('stepthree') ? 'none' : 'block',
        }, "aria-hidden": true, onTouchStart: (e) => ontouchStart(e), onClick: (e) => e.stopPropagation() }, { children: [_jsx("div", Object.assign({ className: style['item-wrap'] }, { children: openState
                    ? items.map((item) => (_jsxs("div", Object.assign({ className: style.item, "aria-hidden": true, onTouchStart: (e) => { itemClick(e, item.key); }, 
                        // onClick={(e) => { itemClick(e, item.key); e.stopPropagation(); }}// 兼容androd
                        onTouchEnd: (e) => { touchEnd(e); } }, { children: [_jsx("img", { src: item.img, alt: "" }, void 0),
                            _jsx("div", Object.assign({ className: `${style.text} ${!initState.existWindow && item.key === 2 ? style.matte : ''}` }, { children: item.text }), void 0)] }), item.key))) : null }), void 0),
            _jsx("div", Object.assign({ "aria-hidden": true, onTouchStart: (e) => offOnFn(e), className: style['img-wrap'], style: { height: openState ? '2.25rem' : '3.125rem' } }, { children: _jsx("img", { className: style.switch, src: openState ? barDown : barSetting, alt: "", style: openState ? {
                        height: '1.25rem', width: '1.25rem', left: '1rem', bottom: '1rem',
                    }
                        : {
                            height: '1.5rem', width: '1.5rem', left: '.875rem', bottom: '.875rem',
                        } }, void 0) }), void 0),
            _jsx(OptionsCard, { wallId: selectedWallId, floorId: selectedFloorId, visible: visible, type: type, listWall: listWall, listFloor: listFloor, itemClick: colorClick }, void 0)] }), void 0));
}
SideBar.propTypes = {
    pathname: PropTypes.string.isRequired,
    floorList: PropTypes.oneOfType([PropTypes.array]).isRequired,
    wallList: PropTypes.oneOfType([PropTypes.array]).isRequired,
    isHome: PropTypes.bool.isRequired,
};
export default SideBar;
